import React from 'react';
import { Link } from 'react-router-dom';

// Import images
import cup110_1 from '../assets/images/cup110_1.jpg';
import cup220_1 from '../assets/images/c5.jpg';
import spoon from '../assets/images/spoon1.jpg';
import fork from '../assets/images/fork1.jpg';
import stirrer from '../assets/images/stirrer1.jpg';
import icecream from '../assets/images/icecream1.jpg';
import fries from '../assets/images/fries1.jpg';

// Product data for all categories
const allProducts = {
  'edible-cups': [
    {
      id: 'cup-110',
      name: '110ml Edible Cup',
      price: 10.00,
      priceLabel: 'From €10.00',
      image: cup110_1,
      link: '/edible-cup-110',
      category: 'edible-cups'
    },
    {
      id: 'cup-220',
      name: '220ml Edible Cup',
      price: 12.00,
      priceLabel: 'From €12.00',
      image: cup220_1,
      link: '/edible-cup-220',
      category: 'edible-cups'
    }
  ],
  'cutlery-tableware': [
    {
      id: 'spoons',
      name: 'Edible Spoons',
      price: 8.00,
      priceLabel: 'From €2.99',
      image: spoon,
      link: '/cutlery-tableware/edible-spoons',
      category: 'cutlery-tableware'
    },
    {
      id: 'forks',
      name: 'Edible Forks',
      price: 8.00,
      priceLabel: 'From €2.99',
      image: fork,
      link: '/cutlery-tableware/edible-forks',
      category: 'cutlery-tableware'
    },
    {
      id: 'coffee-stirrer',
      name: 'Edible Coffee Stirrer',
      price: 6.00,
      priceLabel: 'From €3.00',
      image: stirrer,
      link: '/cutlery-tableware/edible-coffee-stirrer',
      category: 'cutlery-tableware'
    },
    {
      id: 'ice-cream-spoon',
      name: 'Edible Ice Cream Spoon',
      price: 7.00,
      priceLabel: 'From €2.00',
      image: icecream,
      link: '/cutlery-tableware/edible-ice-cream-spoon',
      category: 'cutlery-tableware'
    },
    {
      id: 'fries-fork',
      name: 'French Fries Fork',
      price: 5.00,
      priceLabel: 'From €2.50',
      image: fries,
      link: '/cutlery-tableware/french-fries-fork',
      category: 'cutlery-tableware'
    }
  ]
};

const RelatedProducts = ({ currentProductId, category }) => {
  // Get products from the same category, excluding current product
  const categoryProducts = allProducts[category] || [];
  const sameCategoryProducts = categoryProducts.filter(product => product.id !== currentProductId);
  
  // Get products from other categories
  const otherCategories = Object.keys(allProducts).filter(cat => cat !== category);
  let otherCategoryProducts = [];
  for (const otherCategory of otherCategories) {
    otherCategoryProducts = [...otherCategoryProducts, ...(allProducts[otherCategory] || [])];
  }
  
  // Combine: same category first, then other category products
  // For Edible Cups: show the other cup + all cutlery (6 products total)
  // For Cutlery: show all other cutlery + both cups (6 products total)
  let displayProducts = [...sameCategoryProducts, ...otherCategoryProducts];
  
  // Limit to 6 products max for display (to show all related products)
  displayProducts = displayProducts.slice(0, 6);
  
  if (displayProducts.length === 0) return null;

  return (
    <section className="related-products-section">
      <div className="container">
        <div className="related-products-header">
          <h2>You Might Also Like</h2>
          <p>Explore more of our sustainable edible products</p>
        </div>
        
        <div className="related-products-grid">
          {displayProducts.map((product) => (
            <Link 
              key={product.id} 
              to={product.link} 
              className="related-product-card"
            >
              <div className="related-product-image">
                <img 
                  src={product.image} 
                  alt={product.name}
                />
              </div>
              <div className="related-product-info">
                <h3>{product.name}</h3>
                <span className="related-product-price">{product.priceLabel}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
